import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

let deferred = null;
const subs = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; subs.forEach(f => f()); });
  window.addEventListener("appinstalled", () => { deferred = null; localStorage.setItem("feemitra_installed", "1"); subs.forEach(f => f()); });
}

const KEY = "feemitra_install_dismissed";
const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isAndroid = () => /android/i.test(navigator.userAgent);
const inAppBrowser = () => /FBAN|FBAV|Instagram|WhatsApp|Line\/|; wv\)/i.test(navigator.userAgent);
const manualHelp = () => isIOS() ? <>Safari mein neeche <Share size={13} /> Share dabayein → "Add to Home Screen" → Add</>
  : inAppBrowser() ? <>Upar ⋮ menu dabakar "Chrome mein kholein" chunein, phir wahan Install karein</>
  : <>Chrome mein upar ⋮ menu → "Install app" ya "Add to Home screen" dabayein</>;
const dismissedRecently = () => Date.now() - Number(localStorage.getItem(KEY) || 0) < 7 * 864e5;

export function InstallAppBanner() {
  const [, force] = useState(0);
  const [hidden, setHidden] = useState(() => isStandalone() || dismissedRecently());
  const [iosHelp, setIosHelp] = useState(false);
  useEffect(() => { const f = () => force(n => n + 1); subs.add(f); return () => subs.delete(f); }, []);
  if (hidden || (!deferred && !isIOS() && !isAndroid())) return null;
  const later = () => { localStorage.setItem(KEY, String(Date.now())); setHidden(true); };
  const install = async () => {
    if (!deferred) { setIosHelp(true); return; }
    deferred.prompt();
    const { outcome } = await deferred.userChoice; deferred = null;
    if (outcome === "accepted") { localStorage.setItem("feemitra_installed", "1"); setHidden(true); } else later();
  };
  return <div className="install-banner" data-testid="install-app-banner">
    <img src="/icon-192.png" alt="" className="install-icon" />
    <div className="install-text">
      <b>FeeMitra app install karein</b>
      {iosHelp ? <small data-testid="install-ios-help">{manualHelp()}</small>
        : <small>Phone ki home screen se seedha kholein — app jaisa</small>}
    </div>
    {!iosHelp && <button className="primary-btn small" onClick={install} data-testid="install-app-button"><Download size={14} /> Install</button>}
    <button className="install-close" onClick={later} aria-label="Baad mein" title="Baad mein" data-testid="install-app-later"><X size={16} /></button>
  </div>;
}
